export default __webpack_public_path__ + "assets/images/0b2c35442a2da12f3db51aae6dd9c5f7.svg";